module.exports = __webpack_public_path__ + "img/melon-half.4447ef14.svg";